//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import bottom from '@/assets/img/bottom.png'
import {getUrlparams,countDownTimeFunc,toCopy} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';
import {getToken, setToken, removeToken} from "@/utils/auth";

export default {
  name: "Login",
  components: {
    footerNav
  },
  computed: {
    canSubmit(){
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      return reg_tel.test(this.mobile)
    }
  },
  data() {
    return {
      mobile:'',
      openId:''
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.openId) {
      this.openId = this.$route.query.openId
      console.log(this.openId)
    }
  },
  updated() {
    document.scrollingElement.scrollTop = 0
  },
  methods: {
    login(){
      var params={openId:this.openId,mobile:this.mobile}
      axiosApi.wechatRelatedUser(params).then(res => {
        setToken(res.content.token)
        this.$store.commit('SET_TOKEN', res.content.token);
        this.$store.dispatch('GetUserMenus').then(res => { // 拉取user_info
          this.$router.push(this.$store.state.historyRoute)
        }).catch((err) => {
          Toast.fail('手机号不存在，请联系管理员添加');
          removeToken()
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/index.vue